// extracted by mini-css-extract-plugin
export default {"box":"MatchImages_box__YhSR+","title":"MatchImages_title__PNRAa","pair":"MatchImages_pair__8ljbF","cell":"MatchImages_cell__syKB-","deleteVariant":"MatchImages_deleteVariant__M6FIx"};